import { apiClient } from './client';
import type { AdminActionWithUser, AdminActionSearchFilters, AdminActionEntityType } from '../../types';

export const adminActionsService = {
  list: async (filters: AdminActionSearchFilters = {}): Promise<{ actions: AdminActionWithUser[] }> => {
    return apiClient.get<{ actions: AdminActionWithUser[] }>('/api/v1/admin-actions', filters);
  },

  search: async (filters: AdminActionSearchFilters = {}): Promise<{ actions: AdminActionWithUser[] }> => {
    return apiClient.get<{ actions: AdminActionWithUser[] }>('/api/v1/admin-actions', filters);
  },

  getRecent: async (limit?: number): Promise<{ actions: AdminActionWithUser[] }> => {
    return apiClient.get<{ actions: AdminActionWithUser[] }>('/api/v1/admin-actions/recent', limit ? { limit } : undefined);
  },

  getById: async (id: string): Promise<AdminActionWithUser> => {
    return apiClient.get<AdminActionWithUser>(`/api/v1/admin-actions/${id}`);
  },

  getByEntity: async (
    entityType: AdminActionEntityType,
    entityId: string,
    limit?: number
  ): Promise<{ actions: AdminActionWithUser[] }> => {
    return apiClient.get<{ actions: AdminActionWithUser[] }>(
      `/api/v1/admin-actions/entity/${entityType}/${entityId}`,
      limit ? { limit } : undefined
    );
  },

  getByUser: async (userId: string, limit?: number): Promise<{ actions: AdminActionWithUser[] }> => {
    return apiClient.get<{ actions: AdminActionWithUser[] }>(
      `/api/v1/admin-actions/user/${userId}`,
      limit ? { limit } : undefined
    );
  },
};
